import HttpClient from "../../../core/HttpClient";
import Utility from "../../../core/helpers/utility";
import IQuestion, { IAnswer, UserInfo } from "../domain/AssistantTypes";

export default class DataService {
  private httpClient: HttpClient<IQuestion>;
  constructor() {
    this.httpClient = new HttpClient<IQuestion>();
  }

  public fetchQuestions(groups: string[]): Promise<IQuestion[]> {

    const query = groups.join(',');
    // console.log(query);
    return this.httpClient.get<IQuestion[]>(`/assistant?groups=${query}`); //-security?groups=${query}
  }

  public sendToServer(data: any): void {
    this.httpClient.post('/assistant', data).then(res => console.log(res));
  }

  //read information such as Full Name, Phone Number, Business Name, Email Address
  public saveUserInfo() {
    if (Utility.isLocalURL()) return;
    //read query string
    const query = window.location.search.substring(1);
    this.store(Items.User, query);
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  public getUserInfo(): UserInfo {
    const query = localStorage.getItem(Items.User)!;
    const params = new URLSearchParams(JSON.parse(query));
    return {
      fullName: params.get('FullName')!,
      businessName: params.get('BusinessName')!,
      email: params.get('EmailAddress')!,
      phone: params.get('PhoneNumber')!,
    };
  }

  public store(item: string, data: any): void {
    if (localStorage.getItem(item)) localStorage.removeItem(item);
    localStorage.setItem(item, JSON.stringify(data));
  }

  public saveQuestions(data: IQuestion[]) {
    this.store(Items.Questions, data);
  }
  public saveGroups(data: string[]) {
    this.store(Items.Groups, data);
  }

  public getRawQuestions(): IQuestion[] {
    const str = localStorage.getItem(Items.Questions);
    if (!str || str.length == 0) return [];
    return JSON.parse(str) as IQuestion[];
  }

  public getGroups(): string[] {
    const str = localStorage.getItem(Items.Groups);
    if (!str || str.length == 0) return [];
    return JSON.parse(str) as string[];
  }

  public saveAnswers(data: IAnswer[]) {
    this.store(Items.Answers, data);
  }

  public getAnswers(): IAnswer[] {
    const str = localStorage.getItem(Items.Answers);
    if (!str || str.length == 0) return [];
    return JSON.parse(str) as any;
  }

}

enum Items {
  Questions = "question",
  Groups = "groups",
  Answers = "answers",
  User = "user"
}